<template>
  <section id="cta" class="section cta-section">
    <div v-reveal class="cta-inner">
      <h2>开启你的数字化升级之路</h2>
      <a-space size="large" wrap>
        <a-button class="cta-primary" type="primary" size="large" @click="goContact">
          免费产品演示
        </a-button>
        <a-button class="cta-ghost" size="large" ghost @click="goContact">联系销售顾问</a-button>
      </a-space>
    </div>
  </section>
</template>

<script>
export default {
  methods: {
    goContact() {
      const el = document.getElementById("contact");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }
};
</script>

<style scoped>
.section {
  width: calc(100% - 64px);
  margin: 26px auto 18px;
  border-radius: 18px;
  padding: 0;
  box-shadow: 0 10px 30px rgba(14, 48, 118, 0.11);
  overflow: hidden;
  border: 1px solid rgba(170, 204, 255, 0.35);
}

.cta-inner {
  padding: 40px 32px;
  text-align: center;
  background: linear-gradient(132deg, #0f2f73, #1f59ca 52%, #2f8bf2);
  color: #fff;
}

.cta-inner h2 {
  margin: 0 0 22px;
  font-size: 26px;
  font-weight: 700;
  color: #fff;
}

.cta-section /deep/ .ant-btn-primary.cta-primary {
  min-width: 148px;
  height: 44px;
  font-weight: 600;
  border: none;
  background: #fff;
  color: #1f59ca;
}

.cta-section /deep/ .ant-btn-primary.cta-primary:hover {
  background: rgba(255, 255, 255, 0.95);
  color: #1746a0;
}

.cta-section /deep/ .cta-ghost {
  color: #fff !important;
  border-color: rgba(255, 255, 255, 0.65) !important;
  background: transparent !important;
}

.cta-section /deep/ .cta-ghost:hover {
  border-color: #fff !important;
  color: #fff !important;
}

@media (max-width: 991px) {
  .section {
    width: calc(100% - 28px);
  }

  .cta-inner {
    padding: 32px 20px;
  }

  .cta-inner h2 {
    font-size: 20px;
  }
}
</style>
